/**
 * Convert a number to words, works for anything < 1000.
 */
export function numberToWords(n: number): string {
  // not supported
  if (n < 0 || n >= 1000) return `${n}`;

  // 0..99
  if (n < 100) return hundred(n);

  // 100..999
  let s = `${hundred(Math.floor(n / 100))} hundred`;
  if (n % 100) s = `${s} ${hundred(n % 100)}`;
  return s;
}

const TWENTY = (
  "zero one two three four five six seven eight nine ten " +
  "eleven twelve thirteen fourteen fifteen sixteen seventeen eighteen nineteen"
).split(" ");
const TENS = "xx xx twenty thirty forty fifty sixty seventy eighty ninety".split(" ");

// helper for anything < 100
function hundred(n: number): string {
  if (n < 20) return TWENTY[n];
  let s = TENS[Math.floor(n / 10)];
  if (n % 10) s = `${s}-${hundred(n % 10)}`;
  return s;
}
